// Module
var code = "<section class=\"home-landing-section lg:tw-min-h-screen\">\n    <ng-transclude></ng-transclude>\n</section>\n";
// Exports
module.exports = code;